import { render, staticRenderFns } from "./Attorneys.vue?vue&type=template&id=172bf8df"
import script from "./Attorneys.vue?vue&type=script&lang=js"
export * from "./Attorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports